module.exports = "<tabset>\n  <tab heading=\"Administración de Iframes Dinánicos\" id=\"tabIframes\">\n    <div class=\"col-12 mt-2\">\n      <iw-dynamic-iframes></iw-dynamic-iframes>\n    </div>\n  </tab>\n</tabset>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/iframe-management/iframe-management.component.html
// module id = ./src/app/administration/iframe-management/iframe-management.component.html
// module chunks = main